import type { PageProps } from '../app';
import { href } from '../router';
import { Icon } from '../ui/components/Icon';

export function NotFound(_props: PageProps) {
  return (
    <main class="content">
      <h1>Page not found</h1>
      <p class="muted">That address does not match anything in the explorer.</p>
      <a class="btn" href={href('/logs')}><Icon name="arrowLeft" /> All logs</a>
    </main>
  );
}
